const actions = {
  CREATE_SUBSCRIPTION_BEGIN: "CREATE_SUBSCRIPTION_BEGIN",
  CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
  CREATE_SUBSCRIPTION_ERR: "CREATE_SUBSCRIPTION_ERR",

  LIST_SUBSCRIPTIONS_BEGIN: "LIST_SUBSCRIPTIONS_BEGIN",
  LIST_SUBSCRIPTIONS_SUCCESS: "LIST_SUBSCRIPTIONS_SUCCESS",
  LIST_SUBSCRIPTIONS_ERR: "LIST_SUBSCRIPTIONS_ERR",

  UPDATE_SUBSCRIPTION_BEGIN: "UPDATE_SUBSCRIPTION_BEGIN",
  UPDATE_SUBSCRIPTION_SUCCESS: "UPDATE_SUBSCRIPTION_SUCCESS",
  UPDATE_SUBSCRIPTION_ERR: "UPDATE_SUBSCRIPTION_ERR",

  DELETE_SUBSCRIPTION_BEGIN: "DELETE_SUBSCRIPTION_BEGIN",
  DELETE_SUBSCRIPTION_SUCCESS: "DELETE_SUBSCRIPTION_SUCCESS",
  DELETE_SUBSCRIPTION_ERR: "DELETE_SUBSCRIPTION_ERR",

  ACTIVATE_SUBSCRIPTION_BEGIN: "ACTIVATE_SUBSCRIPTION_BEGIN",
  ACTIVATE_SUBSCRIPTION_SUCCESS: "ACTIVATE_SUBSCRIPTION_SUCCESS",
  ACTIVATE_SUBSCRIPTION_ERR: "ACTIVATE_SUBSCRIPTION_ERR",

  DEACTIVATE_SUBSCRIPTION_BEGIN: "DEACTIVATE_SUBSCRIPTION_BEGIN",
  DEACTIVATE_SUBSCRIPTION_SUCCESS: "DEACTIVATE_SUBSCRIPTION_SUCCESS",
  DEACTIVATE_SUBSCRIPTION_ERR: "DEACTIVATE_SUBSCRIPTION_ERR",

  GET_SUBSCRIPTION_DETAILS_BEGIN: "GET_SUBSCRIPTION_DETAILS_BEGIN",
  GET_SUBSCRIPTION_DETAILS_SUCCESS: "GET_SUBSCRIPTION_DETAILS_SUCCESS",
  GET_SUBSCRIPTION_DETAILS_ERR: "GET_SUBSCRIPTION_DETAILS_ERR",

  createSubscriptionBegin: () => {
    return {
      type: actions.CREATE_SUBSCRIPTION_BEGIN,
    };
  },

  createSubscriptionSuccess: (data) => {
    return {
      type: actions.CREATE_SUBSCRIPTION_SUCCESS,
      data,
    };
  },

  createSubscriptionErr: (err) => {
    return {
      type: actions.CREATE_SUBSCRIPTION_ERR,
      err,
    };
  },

  listSubscriptionsBegin: () => {
    return {
      type: actions.LIST_SUBSCRIPTIONS_BEGIN,
    };
  },

  listSubscriptionsSuccess: (data) => {
    return {
      type: actions.LIST_SUBSCRIPTIONS_SUCCESS,
      data,
    };
  },

  listSubscriptionsErr: (err) => {
    return {
      type: actions.LIST_SUBSCRIPTIONS_ERR,
      err,
    };
  },

  updateSubscriptionBegin: () => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_BEGIN,
    };
  },

  updateSubscriptionSuccess: (data) => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_SUCCESS,
      data,
    };
  },

  updateSubscriptionErr: (err) => {
    return {
      type: actions.UPDATE_SUBSCRIPTION_ERR,
      err,
    };
  },

  deleteSubscriptionBegin: () => {
    return {
      type: actions.DELETE_SUBSCRIPTION_BEGIN,
    };
  },

  deleteSubscriptionSuccess: (data) => {
    return {
      type: actions.DELETE_SUBSCRIPTION_SUCCESS,
      data,
    };
  },

  deleteSubscriptionErr: (err) => {
    return {
      type: actions.DELETE_SUBSCRIPTION_ERR,
      err,
    };
  },

  activateSubscriptionBegin: () => {
    return {
      type: actions.ACTIVATE_SUBSCRIPTION_BEGIN,
    };
  },

  activateSubscriptionSuccess: (data) => {
    return {
      type: actions.ACTIVATE_SUBSCRIPTION_SUCCESS,
      data,
    };
  },

  activateSubscriptionErr: (err) => {
    return {
      type: actions.ACTIVATE_SUBSCRIPTION_ERR,
      err,
    };
  },

  deactivateSubscriptionBegin: () => {
    return {
      type: actions.DEACTIVATE_SUBSCRIPTION_BEGIN,
    };
  },

  deactivateSubscriptionSuccess: (data) => {
    return {
      type: actions.DEACTIVATE_SUBSCRIPTION_SUCCESS,
      data,
    };
  },

  deactivateSubscriptionErr: (err) => {
    return {
      type: actions.DEACTIVATE_SUBSCRIPTION_ERR,
      err,
    };
  },

  getSubscriptionDetailsBegin: () => {
    return {
      type: actions.GET_SUBSCRIPTION_DETAILS_BEGIN,
    };
  },

  getSubscriptionDetailsSuccess: (data) => {
    return {
      type: actions.GET_SUBSCRIPTION_DETAILS_SUCCESS,
      data,
    };
  },

  getSubscriptionDetailsErr: (err) => {
    return {
      type: actions.GET_SUBSCRIPTION_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
